export default "__VITE_ASSET__Cm$i0VPT__"